import apiClient from '../network/apiClient'
// import ShowNotifications from '../utils/notification'
// import axios from 'axios';
class dashboardApi {

  async getLatestCustomer(input) {

    try {
      const response = await apiClient.get(`/dashboard/recent-customer`)

      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      // ShowNotifications.showAxiosErrorAlert(error)
      return {
        response: null,
        status: false
      }
    }
  }

  async getTopSelling(input, currency) {
    console.log(input, currency, "iii");

    try {
      const response = await apiClient.get(`/dashboard/top-selling-product`, { params: { dateFilter: input, currency } })

      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      // ShowNotifications.showAxiosErrorAlert(error)
      return {
        response: null,
        status: false
      }
    }
  }

  async getOverAllSales(currency) {
    try {
      const response = await apiClient.get('/dashboard/sales-overview', { params: { currency } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching overall sales:', error);
      throw error;
    }
  }

  async getOverview(input, currency) {
    try {
      const response = await apiClient.get('/dashboard/by-month', { params: { filterType: input, currency } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching overview:', error);
      throw error;
    }
  }

  async getInvoice() {
    try {
      const response = await apiClient.get('/dashboard/invoices');
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  }

  async getLowStock() {
    try {
      const response = await apiClient.get('/dashboard/lowstock');
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching low stock:', error);
      throw error;
    }
  }

  async getOrderStatusCount(input) {
    try {
      const response = await apiClient.get('/dashboard/order-status-count', { params: { filterType: input } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching order status count:', error);
      throw error;
    }
  }

  async getCategoryByRevenue(input, currency) {
    try {
      const response = await apiClient.get('/dashboard/category-by-revenue', { params: { filterType: input, currency } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching category by revenue:', error);
      throw error;
    }
  }

  async getTopCustomers(input, currency) {
    try {
      const response = await apiClient.get('/dashboard/top-customers', { params: { filterType: input, currency } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching category by revenue:', error);
      throw error;
    }
  }

  async getOrdersByCurrency(input) {
    try {
      const response = await apiClient.get('/dashboard/orders-by-currency', { params: { filterType: input } });
      return response.data;
    } catch (error) {
      console.error('Error fetching orders by currency:', error);
      throw error;
    }
  }

}

const DashboardApi = new dashboardApi()
export default DashboardApi
